import React, { Dispatch, SetStateAction } from 'react';

import { Box } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { BulkUploadDownloadButton } from 'screens/admin/Employees/BulkUploadSidePanel/components/BulkUploadDownloadButton';

import CheckInErrorIllustration from 'assets/assetsV1/illustrations/deerIllustrations/checkInError.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { TextHeader1, TextLabel } from 'uiToolkitV1/Typography';

const Heading = () => (
  <Box display="flex" justifyContent="center" alignItems="center" marginBottom="16px" width="100%">
    <TextHeader1 fontSize="20px" lineHeight="32px" fontWeight="600" color="#C62C02">
      Oops! Something went wrong.
    </TextHeader1>
  </Box>
);

const ErrorDescription = ({
  onClickGoToCheckIn,
  uuid,
  fileName,
}: {
  onClickGoToCheckIn: Dispatch<SetStateAction<boolean>>;
  uuid: string;
  fileName: string;
}) => (
  <Box
    display="flex"
    flexDir="column"
    justifyContent="center"
    alignItems="center"
    padding="16px"
    flex="1"
    width="100%"
    border="1px dashed #CFD7DF"
    borderRadius="8px"
  >
    <TextLabel color="#D42E1C">Looks like we couldn&apos;t check-in to all the goals. </TextLabel>
    {uuid && (
      <TextLabel color="#D42E1C">
        <BulkUploadDownloadButton
          uuid={uuid}
          fileName={fileName || 'MeshCSV.csv'}
          text="Download"
          buttonStyles={{
            height: 'auto',
            padding: '0px!important',
            sx: { '.chakra-text': { fontSize: '12px', margin: '0px!important', lineHeight: '15px' } },
          }}
        />
        &nbsp; this file to see the details.
      </TextLabel>
    )}
    <Button variant="filled" onClick={() => onClickGoToCheckIn(false)} style={{ marginTop: '12px' }}>
      Go to check-in
    </Button>
  </Box>
);

export default function CheckInErrorScreen({
  onClickGoToCheckIn,
  uuid,
  fileName,
}: {
  onClickGoToCheckIn: Dispatch<SetStateAction<boolean>>;
  uuid: string;
  fileName: string;
}) {
  return (
    <Box width="360px">
      <EmptyScreen
        headerComp={Heading}
        illustrationSrc={CheckInErrorIllustration}
        // eslint-disable-next-line react/no-unstable-nested-components
        descriptionComp={() => (
          <ErrorDescription onClickGoToCheckIn={onClickGoToCheckIn} uuid={uuid} fileName={fileName} />
        )}
      />
    </Box>
  );
}
